import {Injectable} from '@angular/core';
import { BehaviorSubject , throwError } from 'rxjs';
import { ShareDataService as ShareDataServiceGeneric } from '@signature-it/ngx-generic/services';
import {Group} from "@signature-it/ngx-catalogue/models";

@Injectable({
    providedIn: 'root'
})
export class SharedDataService {
    groupId: any;
    isFilterOpen: boolean = false;
    public setFilterFacet = new  BehaviorSubject(null);
    public facetsData = new  BehaviorSubject(null);
    public filtersData = new  BehaviorSubject(null);
    public getCurrentGroup = new BehaviorSubject(<Group>null);
    public clickedFilter = new BehaviorSubject(null);
    public hideSidebar = new BehaviorSubject(null);
    public removeSidebar = new BehaviorSubject(null);
    public isFamilyPage = new BehaviorSubject(null);
    public getQueryParams = new BehaviorSubject(null);
    public loadGroup = new BehaviorSubject(null);
    public ngxSidebarCmp = new BehaviorSubject(null);
    public itemsCount: number;

    constructor(public sharedDataService: ShareDataServiceGeneric){}

    setFacets(data, groupId?) {
        if (!data || !data.facet_counts) return;
        let facets = data;
        facets.highlighting = data.highlighting;
        facets.groupId = groupId;
        if(data.grouped) {
            const groupKey = Object.keys(data.grouped)[0]; // could be GroupFamilyName_s or bucket_parent_id_s
            facets.items = data.grouped[groupKey].groups;
            facets.totalItems = data.grouped[groupKey].ngroups;
            facets.totalmatches = data.grouped[groupKey].matches;
            facets.isGrouped = true;
        } else {
            facets.items = data.response;
            facets.totalItems = data.response.numFound;
            facets.totalmatches = data.response.matches;
            facets.isGrouped = false;
        }
        if(data['spellcheck'] && data['spellcheck']['suggestions'] && data['spellcheck']['suggestions'].length) {
            let spellcheck = [];
            Array.from(data['spellcheck']['suggestions'])
                .forEach(function(item) {
                    Array.prototype.push.apply(spellcheck, item[1]['suggestion'])
                }, spellcheck);
            facets.spellcheck = spellcheck;
        }
        this.facetsData.next(facets);
    }

    isMobileMode(): boolean {
        return this.sharedDataService.isMobileMode();
        // return document.documentElement.clientWidth	<= 991;
    }

    isBpUp(bp) {
        return this.sharedDataService.isBpUp(bp);
    }



}
